module.exports = __webpack_public_path__ + "img/3.a822621a.png";